const TITLE_WEB = "howto"
const API_URL = "https://howto-admin.ugravity.net/api/"
const MAIN_API_URL = "https://www.p-tax.net/whale-api/"
const IMAGE_URL = "https://howto.ugravity.net/api/image/"
const MODULE_ID = "37"
export { TITLE_WEB, API_URL, MAIN_API_URL, IMAGE_URL, MODULE_ID }
